import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CallbackRouter = () => {
  const navigate = useNavigate();

  const currentLocation = localStorage.getItem('currentLocation') ?? '../dashboard';

  useEffect(() => {
    navigate(
      currentLocation,
    );
  }, [currentLocation, navigate]);

  return <></>;
};

export default CallbackRouter;
